import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuthReadiness } from '@/hooks/useAuthReadiness';
import { Database } from '@/integrations/supabase/types';

export type HeroSettings = Database['public']['Tables']['hero_settings']['Row'];

const fetchHeroSettings = async () => {
    // Fetching hero settings
    
    try {
        const { data, error } = await supabase
            .from('hero_settings')
            .select('*')
            .eq('id', 'main')
            .single();

        if (error) {
            console.error('Error fetching hero settings:', error);
            throw error;
        }

        // Successfully fetched hero settings
        return data;
    } catch (error) {
        console.error('Failed to fetch hero settings:', error);
        // Return default settings instead of throwing
        return {
            id: 'main',
            content_interval_ms: 8000,
            carousel_interval_ms: 5000,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
        } as HeroSettings;
    }
};

export const useHeroSettings = () => {
    const { canQueryPublicData } = useAuthReadiness();
    
    return useQuery({
        queryKey: ['heroSettings'],
        queryFn: fetchHeroSettings,
        staleTime: 5 * 60 * 1000, // 5 minutes
        enabled: canQueryPublicData,
        retry: (failureCount, error: any) => {
            // Don't retry if it's an RLS policy error
            if (error?.message?.includes('row-level security policy')) {
                // RLS policy error detected, not retrying
                return false;
            }
            return failureCount < 3;
        },
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000),
    });
};